import { useQuery } from '@tanstack/react-query';

import { bamsShortsApi } from 'api/bamsShorts';

import { BAMS_SHORTS_GC_TIME, BAMS_SHORTS_QUERY_KEY } from './bamsShortsQueryKeys';

const LIVE_REFETCH_INTERVAL = 5 * 60_000;

/**
 * BAMS live view of out-of-stock scans in the last 24 hours. Lazy (enable only on the
 * Live tab) and self-refreshing every 5 minutes. `refetchIntervalInBackground` is left
 * at its default (false) so the poll pauses while the browser tab is not focused.
 *
 * A failed API status throws so the Live tab shows a load error rather than an empty view.
 *
 * @param {Object} params
 * @param {boolean} [params.enabled=false]
 * @returns {import('@tanstack/react-query').UseQueryResult<Array<Object>, Error>}
 */
export const useBamsShortsLiveQuery = ({ enabled = false }) =>
    useQuery({
        queryKey: [BAMS_SHORTS_QUERY_KEY, 'live'],
        enabled,
        staleTime: 0,
        gcTime: BAMS_SHORTS_GC_TIME,
        refetchInterval: enabled ? LIVE_REFETCH_INTERVAL : false,
        queryFn: async () => {
            const resp = await bamsShortsApi.getLive();
            if (resp?.status === false) {
                throw new Error(resp?.msg || 'Could not load the live view.');
            }
            return resp?.data?.rows || [];
        },
    });
